import "./index.css";
import { jsx as i, jsxs as o } from "react/jsx-runtime";
import { Button as e } from "@design-system/button";
import { CtaBlock as a } from "@design-system/cta-block";
import { Icon as s } from "@design-system/icon";
import { Typography as n } from "@design-system/typography";
import { Modal as l } from "@phx-husky/modal";
import t from "classnames";
import { forwardRef as c } from "react";
var d = c(function (_ref) {
  var c = _ref.className,
    d = _ref.isShowing,
    r = _ref.close,
    m = _ref.closeModal,
    g = _ref.disableOnClickClose,
    w = _ref.title,
    b = _ref.description,
    p = _ref.closeAriaLabel,
    u = _ref.primaryButtonLabel,
    _ = _ref.primaryButtonAriaLabel,
    h = _ref.secondaryButtonLabel,
    y = _ref.secondaryButtonAriaLabel,
    _ref$closeIconSize = _ref.closeIconSize,
    v = _ref$closeIconSize === void 0 ? "large" : _ref$closeIconSize,
    N = _ref.onPrimaryButtonClick,
    _ref$mode = _ref.mode,
    f = _ref$mode === void 0 ? "default" : _ref$mode,
    _ref$showCloseButton = _ref.showCloseButton,
    O = _ref$showCloseButton === void 0 ? !0 : _ref$showCloseButton,
    _ref$showOverlay = _ref.showOverlay,
    C = _ref$showOverlay === void 0 ? !0 : _ref$showOverlay,
    _ref$showIcon = _ref.showIcon,
    k = _ref$showIcon === void 0 ? !1 : _ref$showIcon,
    _ref$iconType = _ref.iconType,
    j = _ref$iconType === void 0 ? "tooltip" : _ref$iconType;
  return i(l, Object.assign({
    isShowing: d,
    close: r,
    disableOnClickClose: g,
    className: t("cds-dialog-window", c, {
      "cds-dialog-window__inverse": "default" !== f
    }),
    ariaLabel: w,
    showOverlay: C
  }, {
    children: o("div", Object.assign({
      className: "cds-dialog-window__content"
    }, {
      children: [O && p ? i("div", Object.assign({
        className: "cds-dialog-window__close-button-container"
      }, {
        children: i(e, Object.assign({
          className: "cds-dialog-window__close-button",
          "aria-label": p,
          onClick: function onClick() {
            return m();
          },
          variant: "subtle-icon",
          iconPrefix: {
            props: {
              icon: "close"
            }
          },
          size: v,
          autoFocus: !0
        }, {
          children: p
        }))
      })) : null, k ? i("div", Object.assign({
        className: "cds-dialog-window__icon-container"
      }, {
        children: i(s, {
          size: 32,
          className: "cds-dialog-window__icon",
          icon: j
        })
      })) : null, w ? i(n, {
        className: "cds-dialog-window__title",
        tag: "h3",
        weight: "bold",
        variant: "headline",
        size: "m",
        content: w
      }) : null, b ? i(n, {
        className: "cds-dialog-window__description",
        tag: "p",
        variant: "body",
        size: "m",
        content: b
      }) : null, i("div", Object.assign({
        className: t("cds-dialog-window__button-container")
      }, {
        children: i(a, {
          data: [{
            elementType: "button",
            variant: "primary",
            size: "large",
            children: u,
            className: "cds-dialog-window__button",
            onClick: N,
            "aria-label": _
          }, {
            elementType: "button",
            variant: "secondary",
            size: "large",
            onClick: m,
            children: h,
            className: "cds-dialog-window__button",
            "aria-label": y
          }]
        })
      }))]
    }))
  }));
});
export { d as Dialog };